module.exports = __webpack_public_path__ + "static/media/logo-poli-color.6a86fcb9.png";